import { render, staticRenderFns } from "./Profile-Avatar.vue?vue&type=template&id=7392e386&scoped=true&"
import script from "./Profile-Avatar.vue?vue&type=script&lang=js&"
export * from "./Profile-Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Avatar.vue?vue&type=style&index=0&id=7392e386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7392e386",
  null
  
)

export default component.exports